import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../App.css";
import 'animate.css';
import WOW from 'wowjs';
import '@fortawesome/fontawesome-free/css/all.min.css';


const About = () => {
  useEffect(() => {
    // Initialize WOW.js for scroll animations
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <section className="py-5 bg-light">
      <Container>
        <Row className="align-items-center">
          {/* Text Section */}
          <Col
            md={6}
            className="wow animate__animated animate__fadeInLeft"
            data-wow-duration="1.5s"
          >
            <h2 className="mb-4">How To Play Game</h2>
            <p>
              Keep the rulebook with you while playing, or scan the QR code on the game box to access the rules online.
            </p>
            <ul>
              <li>The token represents your character in the game.</li>
              <li>After one player completes their turn, the next player will play, followed by the third player, and so on.</li>
              <li>A maximum of 3 players can participate in this game.</li>
              <li>The game is suitable for players aged 12 and above.</li>
              <li>
                On the game board, numbered 0 to 100, there are obstacles at certain points. Some obstacles have specific instructions that must be followed. If you don't understand the instructions, refer to the rulebook provided with the game.
              </li>
            </ul>

            {/* Link to PDF for the Read More Button */}
            <a className="mb-3"
              href={`${process.env.PUBLIC_URL}/General-Rules.pdf`} // Path to the PDF
              target="_blank"
              rel="noopener noreferrer"
              style={{
                marginTop: "20px",
                padding: "10px 15px",
                backgroundColor: "#007bff",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                fontSize: "16px",
                display: "inline-block",
                cursor: "pointer",
              }}
            >
              View Full Rulebook (PDF)
            </a>
          </Col>

          {/* Video Section */}
          <Col
            md={6}
            className="position-relative wow animate__animated animate__fadeInRight"
            data-wow-duration="1.5s"
          >
            <div className="position-relative mt-2">
           
                       <iframe 
                        width="100%"
                         height="300"
                         src="https://www.youtube.com/embed/jD8tvf0OJGk?si=t2J76Abd94iE667N?autoplay=1&loop=1" 
frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="About Game Video"
                className="rounded shadow" 
                         
                        ></iframe>

              {/* Video Button */}
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "center",
                }}
              >
                {/* <a
                  href="https://www.youtube.com/watch?v=Fp6Oqe0sO94"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    padding: "10px 15px",
                    backgroundColor: "#28a745",
                    color: "white",
                    textDecoration: "none",
                    borderRadius: "5px",
                    fontSize: "16px",
                  }}
                >
                  Watch on YouTube
                </a> */}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
